declare global {
  interface Window {
    initCdTma?: (config: { id: number }) => Promise<() => Promise<any>>
    show_6080666?: () => Promise<any>
  }
}

export class Onclicka {
  private static _instance: Onclicka
  private _showFunction: (() => Promise<any>) | null = null

  private constructor() {}

  public static get Instance(): Onclicka {
    if (!Onclicka._instance) {
      Onclicka._instance = new Onclicka()
    }
    return Onclicka._instance
  }

  /**
   * Ініціалізація Onclicka SDK: підключення скрипта + отримання функції показу реклами
   */
  public init(): Promise<void> {
    return new Promise((resolve, reject) => {
      if (this._showFunction) {
        resolve()
        return
      }

      const script = document.createElement('script')
      script.src = 'https://js.onclckvd.com/in-stream-ad-admanager/tma.js'
      script.async = true

      script.onload = () => {
        if (!window.initCdTma) {
          reject(new Error('Onclicka SDK method initCdTma not found'))
          return
        }

        window
          .initCdTma({ id: 6080666 })
          .then((showFn: () => Promise<any>) => {
            this._showFunction = showFn
            ;(window as any).show_6080666 = showFn // опціонально для глобального доступу
            resolve()
          })
          .catch((e: any) => reject(e))
      }

      script.onerror = () => reject(new Error('Failed to load Onclicka SDK script'))

      document.head.appendChild(script)
    })
  }

  /**
   * Показує reward рекламу, повертає Promise
   */
  public showAd_Rewarded(): Promise<any> {
    if (!this._showFunction) {
      return Promise.reject(new Error('Onclicka SDK not initialized'))
    }
    return this._showFunction()
  }
}
